import { IUser } from '@/entities/user/model/types'
import { useEffect, useState } from 'react'
import { IPFSProfileType } from '../profile'
import useRequest from '@/shared/lib/use-request'
import { Button, Label, Switch } from '@/shared/ui'
import { UserCard } from '@/entities/user'
import useNotifier from '@/shared/lib/use-notifier'
import { ContractsStore } from '@/shared/model/store/contracts-store'
import useSaveUser from '@/entities/user/lib/use-save-user-hook'
import { Link } from 'react-router-dom'
import { LangStore } from '@/shared/model/store'
import { UserCheck, UserX } from 'lucide-react'

type Props = {
	profile: IUser & IPFSProfileType
	getUserFetch: () => void
}

const MyNpos = ({ profile }: Props) => {
	const { fetch, result } = useRequest<IUser[]>('listNpo')
	const { getUserNpos, userAddress } = useSaveUser()
	const [isConfirmed, setIsConfirmed] = useState(true)
	const { contracts } = ContractsStore()
	const { langPack } = LangStore()
	const { writeContract } = useNotifier({
		onSuccess() {
			getUserNpos(profile.address)
		}
	})

	const isMy = userAddress === profile.address
	const membership = (address: `0x${string}`, confirmed) => {
		writeContract({
			address: address,
			abi: contracts.SavvaNPO.abi,
			functionName: confirmed ? 'unconfirmMembership' : 'confirmMembership',
			args: []
		})
	}

	useEffect(() => {
		fetch({
			params: {
				user_addr: profile.address,
				confirmed_only: isConfirmed,
				limit: 100
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [profile.address, isConfirmed])

	return (
		<div>
			<div className='flex w-full items-center justify-between gap-4'>
				<Link to='/npo/'>
					<Button variant={'orange'}>{langPack('npo.createButton')}</Button>
				</Link>
				<div className='flex items-center gap-4'>
					<Label>{langPack('npo.onluConfirmed')}</Label>
					<Switch checked={isConfirmed} onCheckedChange={setIsConfirmed} />
				</div>
			</div>
			<div className='mt-4 flex flex-col gap-4'>
				{result &&
					result.map((el: IUser) => (
						<div className='flex w-full justify-between rounded-lg bg-background p-4 shadow-md'>
							<UserCard user={el} />
							{isMy && (
								<Button
									variant={el.confirmed ? 'outline_destructive' : 'outline_success'}
									className='gap-4'
									onClick={() => membership(el.address, el.confirmed)}
								>
									{el.confirmed ? langPack('npo.disable') : langPack('npo.confirm')}
									{el.confirmed ? <UserX size={14} /> : <UserCheck size='14' />}
								</Button>
							)}
						</div>
					))}
			</div>
		</div>
	)
}

export default MyNpos
